import { formatScoreValue } from "@/helpers/number/number.helpers";
import { UseEvaluationPercentageArgs } from "./useEvaluationPercentage.decl";

export function useEvaluationPercentage({
  points,
  maximumPoints,
}: UseEvaluationPercentageArgs) {
  const percentage = formatScoreValue((points / (maximumPoints || 1)) * 100);

  return {
    percentage,
  };
}
